import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import LedgerDetail from './components/LedgerDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageLedger',
  components: {
    LedgerDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;